<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Transportes
      </v-card-title>
      <v-tabs>
        <v-tab :to="{ name: 'locacoes-transportes-recolhimentos' }">
          Recolhimentos
        </v-tab>
        <v-tab :to="{ name: 'locacoes-transportes-entregas' }">
          Entregas
        </v-tab>
        <v-tab :to="{ name: 'locacoes-transportes-todos' }">
          Todos
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <router-view></router-view>
    </v-card>
  </v-container>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {}
};
</script>
